import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { ModalDetails } from '../../../../types/Scoring';
import CommonCardHeader from '../../../../coreComponents/CommonCardHeader';

const ScoringDetails = ({ kind, data }: ModalDetails) => {
  const { t } = useTranslation();
  if (kind === 'answers')
    return (
      <Card>
        <CardHeader>
          <CommonCardHeader title={t('scoring.resultsTable.answers')} />
        </CardHeader>
        <CardBody>
          <ListGroup>
            {data &&
              data.map((a) => (
                <ListGroupItem>
                  <ListGroup>
                    <ListGroupItem className="list-light-primary">
                      <Row>
                        <Col sm="2">
                          <p className="p-0 m-0">{t('scoring.question')}:</p>
                        </Col>
                        <Col sm="10">
                          <p className="p-0 m-0">{a.question}</p>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem className="list-light-secondary">
                      <Row>
                        <Col sm="2">
                          <p className="p-0 m-0">{t('scoring.evidence')}:</p>
                        </Col>
                        <Col sm="10">
                          <p className="p-0 m-0">{a.evidence}</p>
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem className="list-light-info">
                      <Row>
                        <Col sm="2">
                          <p className="p-0 m-0">{t('scoring.feedback')}:</p>
                        </Col>
                        <Col sm="10">
                          <p className="p-0 m-0">{a.feedback}</p>
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem className="list-light-success">
                      <Row>
                        <Col sm="2">
                          <p className="p-0 m-0">{t('scoring.score')}:</p>
                        </Col>
                        <Col sm="10">
                          <p className="p-0 m-0">{a.score}</p>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  </ListGroup>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    );
  if (kind === 'questions')
    return (
      <Card>
        {' '}
        <CardHeader>
          <CommonCardHeader title={t('scoring.resultsTable.questions')} />
        </CardHeader>
        <CardBody>
          <ListGroup>
            {data.map((q) => (
              <ListGroupItem key={q.index}>
                <strong>{q.index}.</strong> {q.question}
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    );
  if (kind === 'transcript')
    return (
      <Card>
        {' '}
        <CardHeader>
          <CommonCardHeader title={t('scoring.resultsTable.transcription')} />
        </CardHeader>
        <CardBody>
          <ListGroup>
            {data.map((t) => (
              <ListGroupItem key={t.id}>
                <div>
                  <strong>{t.speaker}</strong> —{' '}
                  <small>{new Date(t.timestamp).toLocaleString()}</small>
                </div>
                <div>{t.text}</div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    );
  if (kind === 'prompt')
    return (
      <Card>
        {' '}
        <CardHeader>
          <CommonCardHeader title={t('scoring.resultsTable.prompt')} />
        </CardHeader>{' '}
        <CardBody>
          {' '}
          <pre className="whitespace-pre-wrap break-words">{data}</pre>
        </CardBody>
      </Card>
    );
  return null;
};

export default ScoringDetails;
